export const FIRST_PAGE = 0;
export const PAGE_SIZE_OPTIONS = [20, 30, 50];